<template>
  <div class="page">
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="currentPageChange"
      background
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :pager-count="pageCount"
      :page-size="pageSize"
      :layout="layout"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<style lang="scss" scoped>
.page {
  padding: 15px;
  display: flex;
  justify-content: flex-end;
}
</style>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: function() {
        return [10, 20, 30, 40];
      }
    },
    pageCount: {
      type: Number,
      default: 9
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    total: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      currentPageSize: 10
    };
  },
  mounted() {
    this.currentPageSize = this.pageSize;
  },
  methods: {
    /**
     * 每页显示大小修改
     */
    pageSizeChange(currentSize) {
      this.$emit("pageSizeChange", currentSize);
      this.currentPageSize = currentSize;
    },
    /**
     * 当前页变更
     */
    currentPageChange(currentPage) {
      this.$emit("currentPageChange", currentPage);
    }
  }
};
</script>
